import { useTranslation } from 'react-i18next';
import { DiscardModal } from '@components/ui/DiscardModal/DiscardModal';
import type { Delivery, InventoryLevel } from '@interfaces/ILogistics';
import { deliveryTitle } from './lines';

/** A delete staged by a drawer's Edit tab; the modal is what fires it. */
export type IPendingDelete =
  | null
  | { kind: 'delivery'; delivery: Delivery }
  | { kind: 'material'; level: InventoryLevel };

interface IPendingDeleteModalProps {
  pending: IPendingDelete;
  /** Locked since the delete was staged: the server would refuse it, and a
   *  closing drawer would read as success. The refresh dock explains. */
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function PendingDeleteModal({ pending, loading, onCancel, onConfirm }: IPendingDeleteModalProps) {
  const { t } = useTranslation();
  return (
    <DiscardModal
      open={pending !== null}
      onCancel={onCancel}
      loading={loading}
      onConfirm={onConfirm}
      title={
        pending?.kind === 'material'
          ? t('logistics.inventory.confirmDelete.title', { name: pending.level.materialName })
          : t('logistics.pipeline.confirmDelete.title', {
              name: pending ? deliveryTitle(pending.delivery, t) : '',
            })
      }
      description={
        pending?.kind === 'material'
          ? t('logistics.inventory.confirmDelete.body')
          : t('logistics.pipeline.confirmDelete.body', { ref: pending?.delivery.ref ?? '' })
      }
    />
  );
}
